export const BusService = [
    "Glaciar Perito Moreno","Aeropuerto", "Chalten", "Bariloche", "Rio Gallegos","Ushuaia", "Puerto Natales", "Punta Arenas", 
]